import React from 'react'
import {useIntl} from 'react-intl'

import {
  AttendanceV2Payload,
  IncompleteClass,
  UnmarkedStudent,
} from '../../../../modes/attendance/attendanceV2Types'
import {ColumnDef} from './AttendanceV2DataTable'
import AttendanceV2ListSection from './AttendanceV2ListSection'

const UNMARKED_STUDENT_COLUMNS: ColumnDef[] = [
  {key: 'studentName', label: 'Student'},
  {key: 'grade', label: 'Grade'},
  {key: 'section', label: 'Section'},
  {key: 'className', label: 'Class'},
]

const INCOMPLETE_CLASS_COLUMNS: ColumnDef[] = [
  {key: 'className', label: 'Class'},
  {key: 'gradeName', label: 'Grade'},
  {key: 'sectionName', label: 'Section'},
  {key: 'enrolled_count', label: 'Enrolled'},
  {key: 'marked_count', label: 'Marked'},
]

type AttendanceV2SafetyCheckViewProps = {
  payload: AttendanceV2Payload
  theme: 'light' | 'dark'
}

/** Renders a `safety_check` payload: the two roll-call lists (students with no attendance marked
 *  and classrooms with incomplete attendance). The generic result table can't read these because
 *  they live under `unmarkedStudents`/`incompleteClasses` rather than the canonical `rows`. */
const AttendanceV2SafetyCheckView: React.FC<AttendanceV2SafetyCheckViewProps> = ({
  payload,
  theme,
}) => {
  const intl = useIntl()
  const unmarkedStudents = (payload.data?.unmarkedStudents ?? []) as UnmarkedStudent[]
  const incompleteClasses = (payload.data?.incompleteClasses ?? []) as IncompleteClass[]

  if (!unmarkedStudents.length && !incompleteClasses.length) return null

  const borderColor = theme === 'dark' ? 'rgba(255,255,255,0.2)' : 'rgba(0,0,0,0.1)'
  const cardBg = theme === 'dark' ? 'rgba(15, 23, 42, 0.94)' : 'rgba(255,255,255,0.65)'

  return (
    <div
      className='attendance-v2-result mt-2 mb-1 rounded-3 p-2'
      style={{border: `1px solid ${borderColor}`, backgroundColor: cardBg}}
    >
      <AttendanceV2ListSection
        title={intl.formatMessage(
          {id: 'CHATBOT.ATTENDANCE.SAFETY_UNMARKED_TITLE'},
          {count: unmarkedStudents.length}
        )}
        columns={UNMARKED_STUDENT_COLUMNS}
        rows={unmarkedStudents as Record<string, unknown>[]}
        theme={theme}
      />
      <AttendanceV2ListSection
        title={intl.formatMessage(
          {id: 'CHATBOT.ATTENDANCE.SAFETY_INCOMPLETE_TITLE'},
          {count: incompleteClasses.length}
        )}
        columns={INCOMPLETE_CLASS_COLUMNS}
        rows={incompleteClasses as Record<string, unknown>[]}
        theme={theme}
      />
    </div>
  )
}

export default AttendanceV2SafetyCheckView
